import React, { useState, useEffect } from "react";
import usersService from "../services/usersService";

export default function Player2form(props) {
  const { values, errors, setFormData } = props;
  const [player1Details, setPlayer1Details] = useState({ Player1Firstname: '', Player1Lastname: '', Player1Email: '', Player1Telephone: '' });
  const [player2Details, setPlayer2Details] = useState({ Player2Firstname: '', Player2Lastname: '', Player2Email: '', Player2Telephone: '' });

  const token = localStorage.getItem("token");
  //const username = JSON.parse(localStorage.getItem('userData')).email;
  let userData = localStorage.getItem("userData");
  if (userData) {
    userData = JSON.parse(userData);
  }
  const [hidepwdblock, setHidePwdBlock] = useState(false);
  var isloggedin = false;

  const [disableplayertwoinput, setDisablePlayerTwoInput] = useState(false);

  const PlayerTwoMembershipCheck = (ismember) => {
    values.playertwohasmembership = ismember;
    if (ismember) {
      setDisablePlayerTwoInput(true);
    } else {
      setDisablePlayerTwoInput(false);
    }
  };

  const pushFormUp = () => {
    if (typeof setFormData === "function") setFormData({ ...values });
  };

  const updatePlayer1Data = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "Player1Telephone") {
      value = value.replace(/[^\w\s]/gi, "").replace(/[^0-9]/g, "");
      e.target.value = value;
    }
    values[name] = value;
    setPlayer1Details((prev) => ({ ...prev, [name]: value }));
    pushFormUp();
  };

  const updatePlayer2Data = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "Player2Telephone") {
      value = value.replace(/[^\w\s]/gi, "").replace(/[^0-9]/g, "");
      e.target.value = value;
    }
    values[name] = value;
    setPlayer2Details((prev) => ({ ...prev, [name]: value }));
    pushFormUp();
  };

  useEffect(() => {
    if (token != null && userData != null && token != "" && userData != "") {
      isloggedin = true;
      usersService
        .getUserDetailsByUsername(userData.email)
        .then((response) => {
          if (response.hasOwnProperty("data")) {
            if (response.data.length > 0) {
              // If user exist do not create user
              setHidePwdBlock(true);
              let p_data = {};
              values.Player1Firstname = p_data.Player1Firstname =
                response.data[0].FirstName;

              values.Player1Lastname = p_data.Player1Lastname =
                response.data[0].LastName;

              values.Player1Email = p_data.Player1Email =
                response.data[0].email;

              values.Player1Telephone = p_data.Player1Telephone =
                response.data[0].MobileNumber;
              setPlayer1Details(p_data);
              // Propagate prefilled values up so validation sees them.
              pushFormUp();
            }
          }
        })
        .catch((error) => {
          console.log("Check User error : ", error);
        });
    }

    if (values) {
      let player1Data = {};
      if (values.Player1Firstname) {
        player1Data.Player1Firstname = values.Player1Firstname;
      }
      if (values.Player1Lastname) {
        player1Data.Player1Lastname = values.Player1Lastname;
      }
      if (values.Player1Email) {
        player1Data.Player1Email = values.Player1Email;
      }
      if (values.Player1Telephone) {
        player1Data.Player1Telephone = values.Player1Telephone;
      }
      setPlayer1Details(player1Data);

      let player2Data = {};
      if (values.Player2Firstname) {
        player2Data.Player2Firstname = values.Player2Firstname;
      }
      if (values.Player2Lastname) {
        player2Data.Player2Lastname = values.Player2Lastname;
      }
      if (values.Player2Email) {
        player2Data.Player2Email = values.Player2Email;
      }
      if (values.Player2Telephone) {
        player2Data.Player2Telephone = values.Player2Telephone;
      }
      setPlayer2Details(player2Data);
    }
  }, []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 py-4 lg:py-8">
      <div className="grid grid-cols-1 gap-6 lg:px-[40px]">
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            First Name*
          </span>
          <input
            type="text"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player1Firstname"
            name="Player1Firstname"
            value={player1Details.Player1Firstname || ''}
            onChange={updatePlayer1Data}
          />
          <div className="text-right text-red-500 text-xs mt-1 italic first-letter:capitalize">
            {errors.Player1Firstname?.message}
          </div>
        </label>
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            Last Name*
          </span>
          <input
            type="text"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player1Lastname"
            name="Player1Lastname"
            value={player1Details.Player1Lastname || ''}
            onChange={updatePlayer1Data}
          />
          <div className="text-right text-red-500 text-xs mt-1 italic first-letter:capitalize">
            {errors.Player1Lastname?.message}
          </div>
        </label>
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            Email address*
          </span>
          <input
            type="email"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player1Email"
            name="Player1Email"
            value={player1Details.Player1Email || ''}
            onChange={updatePlayer1Data}
          />
          <div className="text-right text-red-500 text-xs mt-1 italic first-letter:capitalize">
            {errors.Player1Email?.message}
          </div>
        </label>
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            Phone Number*
          </span>
          <input
            type="tel"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player1Telephone"
            name="Player1Telephone"
            value={player1Details.Player1Telephone || ''}
            onChange={updatePlayer1Data}
          />
          <div className="text-right text-red-500 text-xs mt-1 italic first-letter:capitalize">
            {errors.Player1Telephone?.message}
          </div>
        </label>
        {hidepwdblock ? null : (
          <label className="block" id="pwd-block">
            <h2 className="text-[#707070] font-semibold text-[18px]">
              ACCOUNT DETAILS
            </h2>
            <span className="text-[#707070] font-medium text-[15px]">
              Your account will be created using the below password if you are
              not registered with us.
            </span>
            <br />
            <br />
            <span className="text-[#939393] font-medium text-[18px]">
              Your Password*
            </span>
            <input
              type="password"
              className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              id="Player1Password"
              name="Player1Password"
              value={player1Details.Player1Password || ''}
              onChange={updatePlayer1Data}
            />
            <div className="text-right text-red-500 text-xs mt-1 italic first-letter:capitalize">
              {errors.Player1Password?.message}
            </div>
          </label>
        )}
      </div>
      <div className="grid grid-cols-1 gap-6 lg:px-[40px]">
        <label
          className={
            isloggedin ? "block pt-6 lg:pt-[20px]" : "block pt-6 lg:pt-[50px]"
          }
        >
          <span className="text-black font-medium text-[17px]">
            PLAYER TWO DETAILS <i>(Optional)</i>
          </span>
          {/* isloggedin ?
					<label className="block">
						<input type="checkbox" className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-offset-0 focus:ring-indigo-200 focus:ring-opacity-50" onChange={(e) => PlayerTwoMembershipCheck(e.target.checked)} />
						<span className="ml-4 font-normal text-[#939393]">Has membership</span>
					</label> : null */}
        </label>
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            First Name
          </span>
          <input
            type="text"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player2Firstname"
            name="Player2Firstname"
            value={player2Details.Player2Firstname || ''}
            onChange={updatePlayer2Data}
            disabled={disableplayertwoinput ? "disabled" : ""}
          />
        </label>
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            Last Name
          </span>
          <input
            type="text"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player2Lastname"
            name="Player2Lastname"
            value={player2Details.Player2Lastname || ''}
            onChange={updatePlayer2Data}
            disabled={disableplayertwoinput ? "disabled" : ""}
          />
        </label>
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            Email address
          </span>
          <input
            type="email"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player2Email"
            name="Player2Email"
            value={player2Details.Player2Email || ''}
            onChange={updatePlayer2Data}
            disabled={disableplayertwoinput ? "disabled" : ""}
          />
        </label>
        <label className="block">
          <span className="text-[#939393] font-medium text-[18px]">
            Phone Number
          </span>
          <input
            type="tel"
            className="mt-1 block w-full rounded-md bg-[#ebebeb] border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
            id="Player2Telephone"
            name="Player2Telephone"
            value={player2Details.Player2Telephone || ''}
            onChange={updatePlayer2Data}
            disabled={disableplayertwoinput ? "disabled" : ""}
          />
        </label>
      </div>
    </div>
  );
}
